export default {
  PRODUCTS_LOADING: '@PRODUCTS_LOADING',
  PRODUCTS_SUCCESS: '@PRODUCTS_SUCCESS',
  PRODUCTS_ERROR: '@PRODUCTS_ERROR',

  PRODUCT_DETAILS_LOADING: '@PRODUCT_DETAILS_LOADING',
  PRODUCT_DETAILS_SUCCESS: '@PRODUCT_DETAILS_SUCCESS',
  PRODUCT_DETAILS_ERROR: '@PRODUCT_DETAILS_ERROR',

  PRODUCT_DETAILS_SET_SKU_INFO: '@PRODUCT_DETAILS_SET_SKU_INFO',

  PRODUCT_CATEGORY_LOADING: '@PRODUCT_CATEGORY_LOADING',
  PRODUCT_CATEGORY_SUCCESS: '@PRODUCT_CATEGORY_SUCCESS',
  PRODUCT_CATEGORY_ERROR: '@PRODUCT_CATEGORY_ERROR',
  PRODUCT_CATEGORY_INFINITE_LIST_LOADING: '@PRODUCT_CATEGORY_INFINITE_LIST_LOADING',

  PRODUCT_LISTING_LOADING: '@PRODUCT_LISTING_LOADING',
  PRODUCT_LISTING_SUCCESS: '@PRODUCT_LISTING_SUCCESS',
  PRODUCT_LISTING_ERROR: '@PRODUCT_LISTING_ERROR',
  PRODUCT_LISTING_UPDATE: '@PRODUCT_LISTING_UPDATE',
  PRODUCT_LISTING_RESET: '@PRODUCT_LISTING_RESET',

  FILTER_OPTIONS_LOADING: '@PRODUCTS_FILTER_OPTIONS_LOADING',
  FILTER_OPTIONS_SUCCESS: '@PRODUCTS_FILTER_OPTIONS_SUCCESS',
  FILTER_OPTIONS_ERROR: '@PRODUCTS_FILTER_OPTIONS_ERROR',

  PRODUCT_ADD_TO_BAG_INFO: '@PRODUCT_ADD_TO_BAG_INFO',
  PRODUCT_ADD_TO_BAG_SUCCESS: '@PRODUCT_ADD_TO_BAG_SUCCESS',
  PRODUCT_ADD_TO_BAG_NO_PROFILE_DATA: '@PRODUCT_ADD_TO_BAG_NO_PROFILE_DATA',

  PRODUCT_SET_PAGE_NUMBER: '@PRODUCT_SET_PAGE_NUMBER',
  PRODUCT_RESET_PAGE_NUMBER: '@PRODUCT_RESET_PAGE_NUMBER',

  SET_FILTER_CATEGORY: '@PRODUCTS_SET_FILTER_CATEGORY',
  CLEAR_FILTER_CATEGORY: '@PRODUCTS_CLEAR_FILTER_CATEGORY',
  CLEAR_ALL_FILTERS: '@PRODUCTS_CLEAR_ALL_FILTERS',
  SET_PRODUCTS_SHOULD_UPDATE: '@PRODUCTS_SET_PRODUCTS_SHOULD_UPDATE',
  APPLY_FILTERS: '@PRODUCTS_APPLY_FILTERS',
  SET_FILTER_LABELS: '@PRODUCTS_SET_FILTER_LABELS',

  SET_CATEGORY_ID: '@PRODUCT_SET_CATEGORY_ID',

  RECENT_PRODUCT_SEARCH_ADD: '@RECENT_PRODUCT_SEARCH_ADD',
  RECENT_PRODUCT_SEARCH_CLEAR: '@RECENT_PRODUCT_SEARCH_CLEAR',

  TRACKERS_LOADING: '@TRACKERS_LOADING',
  TRACKERS_SUCCESS: '@TRACKERS_SUCCESS',
  TRACKERS_ERROR: '@TRACKERS_ERROR',

  TRACKERS_PROFILES_LOADING: '@TRACKERS_PROFILES_LOADING',
  TRACKERS_PROFILES_SUCCESS: '@TRACKERS_PROFILES_SUCCESS',

  TRACKERS_SET_SORTING: '@TRACKERS_SET_SORTING',
  TRACKERS_SET_SEARCHBY: '@TRACKERS_SET_SEARCH',
  TRACKERS_SET_FILTER_FLAG: '@TRACKERS_SET_FILTER_FLAG',

  TRACKERS_SET_CLIENTS: '@TRACKERS_SET_CLIENTS',
  TRACKERS_SET_PRODUCT_DETAILS: '@TRACKERS_SET_PRODUCT_DETAILS',

  REMOVE_TRACKER_PROFILE: 'REMOVE_TRACKER_PROFILE',
  REMOVE_TRACKER: 'REMOVE_TRACKER',

  RESTORE_TRACKERS_STATE: '@TRACKERS_RESTORE_TRACKERS_STATE',
};
